import './Login.css';

import React, { useContext, useState } from 'react';


// After Login image profile
// import profileImg from '../../assets/profile.jpg';

// LogOut Icon
// import LogoutIcon from '@mui/icons-material/Logout';


import { Link , useNavigate  } from 'react-router-dom';

import Helmet from '../../component/Helmet/Helmet';

import { Container, Row, Col } from 'reactstrap';
import Sidebar from '../../component/layouts/Sidebar';
import RightSide from '../../component/layouts/rightSide';
import MobileTopBar from '../../component/layouts/MobileTopBar';
import { AppContext } from '../../context/AppContext';

const Login = () => {

    const navigate = useNavigate();

    const {token, setToken} = useContext(AppContext);

    const [formData, setFormData] = useState({
            phone:'',
            password:'',
    });
        
    const [errors, setErrors] = useState({}); 

    const [serverMessage, setServerMessage] = useState(''); 
        
        
    const handleChanges = (e) => {
        setFormData({...formData, [e.target.name]:e.target.value})
    }
        
        
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({}); 

    console.log(111);
    

    console.log('====================================');
    console.log(formData);
    console.log('====================================');

    console.log(1);
    

    try {
      const response = await fetch('https://dashboard.tiktaka.com/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'

        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      console.log(data);
      setServerMessage(data.message);

      

      if (response.ok) {
            alert("✅ تم التسجيل بنجاح!");
            console.log(data);

            localStorage.setItem('token', data.token); 

            setToken(data.token);
            navigate('/');

        } else if (response.status === 422) {
            setErrors(data.errors);
        } else {
            console.log(data.message);
        }

    } catch (error) {
      console.error(error);
      alert('⚠️ حصل خطأ في الاتصال بالسيرفر');
      alert(error);
    }
  };
        
        

  return (
  <Helmet title='Login'>

    <div className="Login">

    <Sidebar />

    <div className='midSide'>
    <div className='middleSideHome'>

    <MobileTopBar />
      
      {/* Start Main Section */}

        <div className='mainSection'>
            <section>
                <Container>
                    <Row>
                        <Col lg='6' md='6' sm='12' className='loginBox'>
                      <form onSubmit={handleSubmit} className='material-form' >
                        <h1>Login</h1>


                        {serverMessage && (
                          <div style={{ color: "red", marginBottom: "10px" }}>
                            {serverMessage}
                          </div>
                        )}

                        <div className='input-field'>
                            <input type='number' placeholder='phone' name='phone'  value={formData.phone}
                                    onChange={handleChanges} ></input>
                            <label>Phone</label>
                            <span className="bar"></span>
                            {errors.phone && (
                                    <div style={{ color: "red", fontSize: "12px" }}>
                                    {errors.phone[0]}
                                    </div>
                            )}
                        </div>


                        <div className='input-field'>
                            <input type='password' placeholder='Password' name='password'  value={formData.password}
                                    onChange={handleChanges}></input>
                              <label>Password</label>
                              <span className="bar"></span>

                            {errors.password && (
                                <div style={{ color: "red", fontSize: "12px" }}>
                                    {errors.password[0]}
                                </div>
                            )}
                        </div>

                        <div className='rememberForget'>
                            <Link to='/register'>Create new account</Link> / 
                            <Link to='/forgetpass'> Forget Password</Link>
                        </div>
                        <button type='submit'>Submit</button>
                        </form>



                        </Col>
                    </Row>
                </Container>
           </section>
        </div>
     {/* End Main Section  */}
    </div>
    </div>


    <RightSide />
   
  </div>
  </Helmet>
  );
};

export default Login;